// extracted by mini-css-extract-plugin
export const root = "fc-content-block-media-module--root--gkZAQ";
export const image = "fc-content-block-media-module--image--7m-VA";
export const video = "fc-content-block-media-module--video--Xdrt-";
export const videoWrap = "fc-content-block-media-module--videoWrap--2gPxf";
export const cover = "fc-content-block-media-module--cover--2zMgv";
export const action = "fc-content-block-media-module--action--3nw3U";
export const player = "fc-content-block-media-module--player--1CUnn";
export const active = "fc-content-block-media-module--active--2RfTg";